import { gql } from '@apollo/client';

import { ProductFragment } from './Product.graphql';

export const AscProjectFragment = gql`
  fragment AscProject on AscProject {
    id
    name
    description
    startDate
    endDate
    capitalizationStartDate
    capitalizationEndDate
    capitalizationEndDateExtendedFrom
    capitalizationStatus
    predictedCapitalizationStatus
    predictedCapitalizationStatusReason
    predictedCapitalizationStartDate
    predictedCapitalizationEndDate
    predictedCapitalizationEndDateReason
    capitalizableProjectClusteringOverride
    customFieldTeams
    customFieldLaunchDate
    workstreamNames
    ticketCount(fiscalYearId: $fiscalYearId, periodName: $periodName)
    projectOwnerId
    projectOwner {
      id
      fullName
    }
    product {
      ...Product
    }
    clusterType
    isDeterministic
  }
  ${ProductFragment}
`;
